import { render, staticRenderFns } from "./POSfast.vue?vue&type=template&id=06e50bbe&scoped=true"
import script from "./POSfast.vue?vue&type=script&lang=js"
export * from "./POSfast.vue?vue&type=script&lang=js"
import style0 from "./POSfast.vue?vue&type=style&index=0&id=06e50bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e50bbe",
  null
  
)

export default component.exports